import "./ListCourses.css";
import React from "react";
import Button from "react-bootstrap/Button";
import html from "../../../src/Assets/html.jpg";
import myuser from "../../Assets/prof.png";
import {GoPrimitiveDot} from 'react-icons/go'


function ListCourses( {date,description,titre,nom,isAprouved} ) {
  let couleur ='';
  let contenu = '';
  isAprouved===true? couleur = 'green' : couleur = 'red';
  isAprouved===true? contenu = 'Live' : contenu = 'Pending';

  return (
    <tr>
            <td className="d-flex justify-center align-items-center  p-2 ">
              <div className="container-im">
                <img className="ma p-2" src={html} />
              </div>{" "}
              <div>
                <p> {description}</p>

                <span> <strong>{titre}</strong> add {date}</span>
              </div>
            </td>
            <td className=" p-2 ">
              <div className="container-im">
                <img className="mab p-2" src={myuser} />{" "}
                <strong>{nom}</strong>
              </div>
            </td>
            <td className=" p-3 "><GoPrimitiveDot style={{color:`${couleur}`}}  />{contenu}</td>
            <td>{isAprouved===false? <><Button variant="success">Approuve</Button>
              <Button variant="light">Rejette</Button></> :<Button variant="secondary">Modifier le status</Button>}
             
            </td>
          </tr>
  );
};

export default ListCourses;
